import { Box, BoxProps } from '@chakra-ui/react'
import { motion, MotionProps } from 'framer-motion'
import { forwardRef } from 'react'

type MotionBoxProps = BoxProps & MotionProps

export const MotionBox = motion(Box as any)

export default MotionBox
